(function(){
    'use strict';
    class CloudwatchService {
        constructor(CLOUDWATCH_LOGS_REGION, CLOUDWATCH_LOGS_IDENTITY_POOL_ID, CLOUDWATCH_LOG_GROUP_NAME, CLOUDWATCH_LOG_STREAM_NAME, $cookies) {
            if(window.AWS) {
                this.AWS = window.AWS;
                this.AWS.config.region = CLOUDWATCH_LOGS_REGION;
                this.AWS.config.credentials = new this.AWS.CognitoIdentityCredentials({
                    IdentityPoolId: CLOUDWATCH_LOGS_IDENTITY_POOL_ID,
                });

                this.cloudwatchlogs = new this.AWS.CloudWatchLogs();
                this.cloudwatch = new this.AWS.CloudWatch();
            }

            this.nextSequenceId = null;

            this.logGroupName = CLOUDWATCH_LOG_GROUP_NAME;
            this.logStreamName = CLOUDWATCH_LOG_STREAM_NAME;

            this.createLogGroup = true;
            this.createLogStream = true;

            this.$cookies = $cookies;
            this.companyId = null;
            this.companyName = null;
            this.userId = null;
            this.userEmail = null;

            this.LOG_MESSAGES_TO_CAPTURE_DURING_TIMEOUT = 100;
            this.SET_TIMEOUT_MILLISECONDS = 5000;
            this.logEvents = [];
            this.currentTimeout = null;

            this._extractUserCompanyFromToken();
        }

        /* jshint ignore:start */
        _extractUserCompanyFromToken() {
            let gydaTokenCookie = this.$cookies.get('gydaToken');
            if(gydaTokenCookie && window.jwt_decode) {
                let gydaTokenObject = JSON.parse(gydaTokenCookie);
                let gydaTokenString = gydaTokenObject.token;
                let decodedGydaToken = window.jwt_decode(gydaTokenString);
                if(decodedGydaToken.company) {
                    this.companyId = decodedGydaToken.company._id;
                    this.companyName = decodedGydaToken.company.name;
                }

                if(decodedGydaToken.user) {
                    this.userId = decodedGydaToken.user._id;
                    this.userEmail = decodedGydaToken.user.email;
                }
            }
        }
        /* jshint ignore:end */

        sendLogsToCloudwatch(logMessage, logStack) {
            // bail if AWS was not successfully loaded
            if(!this.AWS) {
                return;
            }

            const logObject = {
                browser: window.navigator.userAgent,
                url: window.location.href,
                language: window.navigator.language,
                message: logMessage,
                stack: logStack,
                fhAccountInfo: {
                    company: {
                        id: this.companyId,
                        name: this.companyName
                    },
                    user: {
                        id: this.userId,
                        email: this.userEmail
                    }
                }
            };

            const logEvent = {
                message: JSON.stringify(logObject),
                timestamp: Date.now()
            };

            // we will only capture N messages within our timeout interval.
            // we feel this sample will still give us a great indication of something gone wrong, while not overwhelming the API
            // initially set this to 100 messages in 5 seconds, which seems like it would be a total failure to hit this limit anyways
            if(this.logEvents.length <= this.LOG_MESSAGES_TO_CAPTURE_DURING_TIMEOUT) {
                this.logEvents.push(logEvent);
            }

            // we want to bundle up the log messages every SET_TIMEOUT_MILLISECONDS
            // so that we hit the API less, and also to synchronize the sequential IDs needed for cloudwatch
            clearTimeout(this.currentTimeout);
            this.currentTimeout = setTimeout(() => {
                const logEventsToPush = angular.copy(this.logEvents);
                this.logEvents = [];

                this._putLogEvents(logEventsToPush);
            }, this.SET_TIMEOUT_MILLISECONDS);
        }

        _putLogEvents(logEventsToPush) {
            const parameters = {
                logEvents: logEventsToPush,
                logGroupName: this.logGroupName,
                logStreamName: this.logStreamName
            };

            this._createLogGroup()
                .then(this._createLogStream.bind(this))
                .then(this._getNextSequenceToken.bind(this))
                .then((nextSequenceId) => {
                    parameters.sequenceToken = nextSequenceId;

                    this.cloudwatchlogs.putLogEvents(parameters, (error) => {
                        if (error) {
                            console.error('putLogEvents error', error);
                        }
                    });
                });
        }

        _createLogGroup() {
            // if this has already been created, don't bother trying to recreate it
            if(!this.createLogGroup) {
                return Promise.resolve();
            }

            let parameters = {
                logGroupName: this.logGroupName
            };

            return new Promise((resolve, reject) => {
                this.cloudwatchlogs.createLogGroup(parameters, (error, data) => {
                    if (error) {
                        // fail silently if we have already created this log group
                        if(error.code === 'ResourceAlreadyExistsException') {
                            this.createLogGroup = false;
                            resolve();
                        } else {
                            console.error('_createLogGroup error', error);
                            this.createLogGroup = true;
                            reject(error);
                        }
                    } else {
                        this.createLogGroup = false;
                        resolve(data);
                    }
                });
            });
        }

        _createLogStream() {
            // if this has already been created, don't bother trying to recreate it
            if(!this.createLogStream) {
                return Promise.resolve();
            }

            let parameters = {
                logGroupName: this.logGroupName,
                logStreamName: this.logStreamName
            };

            return new Promise((resolve, reject) => {
                this.cloudwatchlogs.createLogStream(parameters, (error, data) => {
                    if (error) {
                        // fail silently if we have already created this log group
                        if(error.code === 'ResourceAlreadyExistsException') {
                            this.createLogStream = false;
                            resolve();
                        } else {
                            console.error('_createLogStream error', error);
                            this.createLogStream = true;
                            reject(error);
                        }
                    } else {
                        this.createLogStream = false;
                        resolve(data);
                    }
                });
            });
        }

        _getNextSequenceToken() {
            let nextSequenceId = null;

            return this._describeLogStreams()
                .then((results) => {
                    if(results.logStreams) {
                        results.logStreams.some((logStream) => {
                            if(logStream.logStreamName === this.logStreamName) {
                                nextSequenceId = logStream.uploadSequenceToken;
                                return true;
                            }
                        });
                    }

                    return nextSequenceId;
                });
        }

        _describeLogStreams() {
            let parameters = {
                logGroupName: this.logGroupName,
                logStreamNamePrefix: this.logStreamName
            };

            return new Promise((resolve, reject) => {
                this.cloudwatchlogs.describeLogStreams(parameters, (error, data) => {
                    if (error) {
                        console.error('describeLogStreams error', error);
                        reject(error);
                    } else {
                        resolve(data);
                    }
                });
            });
        }
    }

    angular.module('MW.Influencers.CloudwatchService', [
            'Configuration'
        ])
        .service('CloudwatchService', [
            'CLOUDWATCH_LOGS_REGION',
            'CLOUDWATCH_LOGS_IDENTITY_POOL_ID',
            'CLOUDWATCH_LOG_GROUP_NAME',
            'CLOUDWATCH_LOG_STREAM_NAME',
            '$cookies',
            CloudwatchService
        ]);
})();
